import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueEllipseProgress from 'vue-ellipse-progress';

Vue.use(VueEllipseProgress);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)

import InfiniteLoading from 'vue-infinite-loading';

import "./assets/css/theme.css";

Vue.use(InfiniteLoading)

// require("vue-select2");
// Vue.component('v-select2',  require('vue-select2'))
// import vSelect from 'vue-select2'
// Vue.use(vSelect)

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/storage');
require('firebase/functions');
//require('firebase-admin');
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol : 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
// Load the full build.
var _ = require('lodash');
// Your web app's Firebase configuration
var config = {
  apiKey: 'AIzaSyD6Ocqo4joInQwsK-4fa63FGe1RyDmXdmI',
  authDomain: 'parceiro-caixa.firebaseapp.com',
  databaseURL: 'https://parceiro-caixa.firebaseio.com',
  projectId: 'parceiro-caixa',
  storageBucket: 'parceiro-caixa.appspot.com',
  messagingSenderId: '338812933996',
  appId: '1:338812933996:web:af25011af63d15957e4549',
  measurementId: 'G-M03FSPXHK5'
};

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

//var admin = require("firebase-admin");

//var serviceAccount = require("./parceiro-caixa-7320691016e5.json");

//admin.initializeApp({
//  credential: admin.credential.cert(serviceAccount),
//  databaseURL: "https://parceiro-caixa.firebaseio.com"
//});

// Initialize Firebase
const firebaseApp = firebase.initializeApp(config);
export default firebaseApp.firestore();
firebase.functions()

Vue.config.productionTip = false;

firebase.auth().onAuthStateChanged(user => {
   //console.log('Observer: ', user);
   if (user && user.emailVerified) {
     store.dispatch('observer', {
       uid: user.uid,
       name: user.displayName,
       email: user.email,
       emailVerified: true
     });
   } else {
     store.dispatch('observer', null);
   }

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});
